import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class UpdateWorkRequest extends GenericRequest {

    // ConstructionSave
    // {
    //     id: number
    //     name: string
    //     code: string
    //     start_date: string
    //     end_date: string
    //     notes: string
    //     importation_id: number
    //     document_schema_id: number
    //     document_schema_link_id: number
    //     construction_state_id: number
    //     company_id: number
    //     contracts: [
    //         {
    //             contract_id: number
    //             can_add: boolean
    //             can_remove: boolean
    //             children: []
    //             company: {
    //                 id: number
    //                 name: string
    //                 level: number
    //             }
    //         }
    //     ]
    // }

    work;

    constructor(work) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.WORK_ID, { id: work.id }));
        this.work = work;
    }

    overrideRequest() {
        return this.work;
    }
}



// WEBPACK FOOTER //
// ./src/app/works/ws/UpdateWorkRequest.js